import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  selector: 'app-input',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    TegelModule,
  ],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
})
export class InputComponent {
  @Input() label = '';
  @Input() type = 'text';
  @Input() size = 'lg';
  @Input() placeholder = '';
  @Input() maxLength = '';
  @Input() readOnly = false;
  @Input() disabled = false;

  value = '';

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: (value: string) => void = () => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  handleInput(event: any) {
    const val = event.target?.value || event.detail?.value || '';
    this.updateValue(val);
  }

  updateValue(inputValue: string) {
    this.value = inputValue;
    this.onChange(inputValue);
    // this.onTouched();
  }
}
